module.exports = "/assets/data/d7aadcb91813ef7319b1f5546499fb8c-HS2.data.json";